import React, { PropTypes, Component } from 'react';
import { connect } from "react-redux";
import { signinSilent } from "./actions.js";

class AuthenticationContainer extends Component {
    constructor(props) {
        super(props);

        props.signinSilent();
    }

    render() {
        const props = this.props;

        return (props.loginAttempted ? <div>{props.children}</div> : <div></div>);
    }
}

AuthenticationContainer.propTypes = {
    children: PropTypes.element,
    loginAttempted: PropTypes.bool,
    signinSilent: PropTypes.func
};

const mapStateToProps = (state) => {
    const { shared } = state;

    return { loginAttempted: shared.auth.loginAttempted };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signinSilent: () => dispatch(signinSilent)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationContainer);


// WEBPACK FOOTER //
// ./src/features/shared/auth/AuthenticationContainer.jsx